import React, { Component } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import Swal from "sweetalert2";
import $ from "jquery";
import axios from "axios";
import { downloadUrl } from "../Settings/Config";
import api from "../../utils/axios";
import { showContaimerLoader, showLoader, hideLoader, showAlert, hasPermission, showDate } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";

const moduleName = "Portage Bill";
const moduleID = 32;
const currencyList = { AED: "AED", BMD: "BMD", EUR: "€", GBP: "£", INR: "₹", MYR: "MYR", SGD: "SGD", USD: "$" };

const earningFields = [
  { key: "OpeningBalance", label: "Opening Balance" },
  { key: "LoyaltyBonus", label: "Loyalty Bonus" },
  { key: "CrewIncomeTax", label: "Crew Income Tax" },
  { key: "CrewOT", label: "Crew OT" },
  { key: "PBBonus", label: "Bonus" },
  { key: "HoldTankCleaning", label: "Hold / Tank Cleaning" },
  { key: "TravelBasicJoiningBasic", label: "Travel basic / Joining basic" },
  { key: "Standby", label: "Standby" },
  { key: "Laundry", label: "Laundry" },
  { key: "TradeAllowance", label: "Trade Allowance" },
  { key: "DryDockAllowance", label: "Dry Dock Allowance" },
  { key: "HRAWarZoneAllowance", label: "HRA/ War Zone Allowance" },
  { key: "CrewReimbursement", label: "Crew Reimbursement" },
];
const deductionFields = [
  { key: "AirfareRep", label: "Airfare/Rep." },
  { key: "RecoveryExcessPF", label: "Recovery Excess PF" },
  { key: "PFExcessDeductionReversal", label: "PF Excess Deduction Reversal" },
  { key: "CrewPFArrear", label: "Crew PF Arrear" },
  { key: "CrewProvidentFundPayable", label: "Crew Provident Fund payable" },
  { key: "CashAdvance", label: "Cash Advance" },
  { key: "BondedStores", label: "Bonded Stores" },
  { key: "CrewIncomeTaxPayable", label: "Crew Income Tax Payable" },
  { key: "RecoveryExcessWages", label: "Recovery Excess Wages" },
  { key: "OtherDeduction", label: "Other Deduction" },
];
const pageOptions = [
  { label: "10", value: "10" },
  { label: "25", value: "25" },
  { label: "50", value: "50" },
  { label: "75", value: "75" },
  { label: "100", value: "100" },
];
const emptySalaryData = () => {
  const data = {};
  [...earningFields, ...deductionFields].forEach((f) => (data[f.key] = ""));
  return data;
};
const num = (v) => parseFloat(v || 0) || 0;
const round2 = (v) => Math.round((v + Number.EPSILON) * 100) / 100;
// Older contracts saved contractSalary with these camelCase keys before the field names were
// aligned to the backend's PascalCase keys; fall back to them so old records don't total to 0.
const salaryKeyAliases = {
  BasicWages: "basicWages",
  OvertimeWages: "fixedOvertimeAllowance",
  ShipboardAlawance: "shipboardAllowance",
  LeaveWages: "earnedLeaveWage",
  LeaveSubsistence: "leaveSubsistenceAllowance",
  UniformAllowance: "uniformAllowance",
  OwnersSpecialallowance: "ownersSpecialAllowance",
  MiscellaneousAllowance: "miscellaneousAllowance",
  OtherAllowance: "otherAllowance",
  EmloyerPF: "employerPF",
  EmployeePF: "employeePF",
};
const getSalaryValue = (contractSalary, key) => {
  if (!contractSalary) return 0;
  if (contractSalary[key] !== undefined && contractSalary[key] !== null && contractSalary[key] !== "") {
    return num(contractSalary[key]);
  }
  const alias = salaryKeyAliases[key];
  return alias ? num(contractSalary[alias]) : 0;
};

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      billMonth: "",
      billMonthError: false,
      Billvessel: "",
      vesselList: [],
      showExport: false,
      showGeneratePaySlip: false,
      showUnlockPaySlip: false,

      signOnLoading: false,
      signOnResult: [],
      signOnCurrentPage: 1,
      signOnTotalPage: 0,
      signOnTotalRecords: 0,
      pageLimitSignOn: { label: "10", value: "10" },

      signOffLoading: false,
      signOffResult: [],
      signOffCurrentPage: 1,
      signOffTotalPage: 0,
      signOffTotalRecords: 0,
      pageLimitSignOff: { label: "10", value: "10" },

      selectedContract: null,
      viewType: "",
      salaryData: emptySalaryData(),
      NetPay: "",
      NetPayError: "",
    };
  }

  componentDidMount() {
    if (!hasPermission(moduleID, "view")) {
      this.props.history.push("/search");
    } else {
      this.loadVessels();
    }
  }

  getToken() {
    return localStorage.getItem("token");
  }

  isAdmin() {
    return (localStorage.getItem("nemouserId") || "") === "1";
  }

  loadVessels() {
    api
      .get("vessel/alldropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result || [];
          const finalVessel = result.filter((v) => v.vesselCode !== "" && v.vesselCode !== null);
          this.setState({ vesselList: finalVessel });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  handleMonthChange = (date) => {
    this.setState({ billMonth: date, billMonthError: false });
  };
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  getBillMonthStr() {
    return this.state.billMonth ? format(this.state.billMonth, "yyyy-MM") : "";
  }

  buildParams() {
    let addParams = `&billMonth=${this.getBillMonthStr()}`;
    if (this.state.Billvessel !== null && this.state.Billvessel !== "" && this.state.Billvessel?.value) {
      addParams += `&vessel=${this.state.Billvessel.value}`;
    }
    return addParams;
  }

  searchBill = (e) => {
    e.preventDefault();
    if (!this.state.billMonth) {
      this.setState({ billMonthError: true });
      return;
    }
    this.setState({ billMonthError: false }, () => {
      this.loadBillList(1, this.state.pageLimitSignOn.value);
      this.loadSignOffBillList(1, this.state.pageLimitSignOff.value);
    });
  };

  loadBillList = (page = 1, limit = 10) => {
    this.setState({ signOnLoading: true, signOnCurrentPage: page });
    axios
      .get(`${downloadUrl}candidate/getportagebill?page=${page}&limit=${limit}${this.buildParams()}`, { headers: { Authorization: this.getToken() } })
      .then((res) => {
        const result = res.data.signOnResult || [];
        this.setState((prev) => ({
          signOnResult: result,
          signOnLoading: false,
          signOnTotalPage: res.data.totalPage || 0,
          signOnTotalRecords: res.data.totalRecord || 0,
          showExport: result.length > 0 ? true : prev.showExport,
          showGeneratePaySlip: result.length > 0 ? true : prev.showGeneratePaySlip,
          showUnlockPaySlip: (result.length > 0 && this.isAdmin()) ? true : prev.showUnlockPaySlip,
        }));
      })
      .catch((err) => {
        this.setState({ signOnLoading: false, signOnResult: [], signOnTotalPage: 0, signOnTotalRecords: 0 });
        console.error(err);
      });
  };

  loadSignOffBillList = (page = 1, limit = 10) => {
    this.setState({ signOffLoading: true, signOffCurrentPage: page });
    axios
      .get(`${downloadUrl}candidate/getportageSignoffbill?page=${page}&limit=${limit}${this.buildParams()}`, { headers: { Authorization: this.getToken() } })
      .then((res) => {
        const result = res.data.signOffResult || [];
        this.setState((prev) => ({
          signOffResult: result,
          signOffLoading: false,
          signOffTotalPage: res.data.totalPage || 0,
          signOffTotalRecords: res.data.totalRecord || 0,
          showExport: result.length > 0 ? true : prev.showExport,
          showGeneratePaySlip: result.length > 0 ? true : prev.showGeneratePaySlip,
          showUnlockPaySlip: (result.length > 0 && this.isAdmin()) ? true : prev.showUnlockPaySlip,
        }));
      })
      .catch((err) => {
        this.setState({ signOffLoading: false, signOffResult: [], signOffTotalPage: 0, signOffTotalRecords: 0 });
        console.error(err);
      });
  };

  sateValChange = (field, value, addParam) => {
    if (addParam === "SignOn") {
      if (field === "page") {
        this.loadBillList(value, this.state.pageLimitSignOn.value);
      } else if (field === "pageLimitSignOn") {
        this.setState({ pageLimitSignOn: value }, () => this.loadBillList(1, value.value));
      }
    } else if (addParam === "SignOff") {
      if (field === "page") {
        this.loadSignOffBillList(value, this.state.pageLimitSignOff.value);
      } else if (field === "pageLimitSignOff") {
        this.setState({ pageLimitSignOff: value }, () => this.loadSignOffBillList(1, value.value));
      }
    }
  };

  viewSalaryBreackup = (item, type, e) => {
    e.preventDefault();
    const portagebillDetails = item?.portagebill || null;
    let BillData = null;
    if (portagebillDetails) {
      BillData = portagebillDetails?.BillData && portagebillDetails.BillData !== "" ? JSON.parse(portagebillDetails.BillData) : null;
    }
    const salaryData = emptySalaryData();
    Object.keys(salaryData).forEach((key) => {
      salaryData[key] = BillData?.[key] || "";
    });
    this.setState(
      {
        selectedContract: item,
        viewType: type,
        salaryData,
        NetPay: portagebillDetails?.BillNetPay || "",
        NetPayError: "",
      },
      () => {
        $("#paySlipDetailsTrigger").trigger("click");
      },
    );
  };

  closeSalaryPopup = () => {
    this.setState({ selectedContract: null, viewType: "", salaryData: emptySalaryData(), NetPay: "", NetPayError: "" });
  };

  handleSalaryFieldChange = (key, value) => {
    const sanitized = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    this.setState((prev) => ({ salaryData: { ...prev.salaryData, [key]: sanitized } }));
  };
  handleNetPayChange = (e) => {
    const sanitized = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    this.setState({ NetPay: sanitized, NetPayError: "" });
  };

  calculateAmount = () => {
    const selectedContract = this.state.selectedContract;
    const contractSalary_ = selectedContract?.contractSalary;

    const contractSalary = contractSalary_ && contractSalary_ !== "" ? JSON.parse(contractSalary_) : {};

    const monthlySalaryDetails =
      getSalaryValue(contractSalary, "BasicWages") +
      getSalaryValue(contractSalary, "OvertimeWages") +
      getSalaryValue(contractSalary, "ShipboardAlawance") +
      getSalaryValue(contractSalary, "LeaveWages") +
      getSalaryValue(contractSalary, "LeaveSubsistence") +
      getSalaryValue(contractSalary, "UniformAllowance") +
      getSalaryValue(contractSalary, "OwnersSpecialallowance") +
      getSalaryValue(contractSalary, "MiscellaneousAllowance") +
      getSalaryValue(contractSalary, "OtherAllowance") +
      getSalaryValue(contractSalary, "EmloyerPF") +
      getSalaryValue(contractSalary, "EmployeePF");

    // Prorate the monthly contract salary by the bill's actual worked days,
    // same formula used server-side in candidate.js (monthlyEarning / lastDate * totalDays)
    const portagebillDetails_ = selectedContract?.portagebill || null;
    const totalDays_ = num(portagebillDetails_?.BillTotalDays || selectedContract?.totalDays);
    const billMonth = this.state.billMonth;
    const daysInBillMonth = billMonth ? new Date(billMonth.getFullYear(), billMonth.getMonth() + 1, 0).getDate() : 0;
    const totalSalaryDetails = round2(daysInBillMonth > 0 && totalDays_ > 0 ? (monthlySalaryDetails / daysInBillMonth) * totalDays_ : monthlySalaryDetails);

    const salaryData = this.state.salaryData;
    const totalEarning = round2(earningFields.reduce((sum, f) => sum + num(salaryData[f.key]), 0));
    const totalDeductions = round2(deductionFields.reduce((sum, f) => sum + num(salaryData[f.key]), 0));
    const totalSalary = round2(totalEarning + totalSalaryDetails - totalDeductions);

    return { totalSalaryDetails, totalEarning, totalDeductions, totalSalary };
  };

  saveSalaryDetails = () => {
    const { totalEarning, totalDeductions, totalSalary } = this.calculateAmount();
    const NetPay = this.state.NetPay;
    let NetPayError = "";
    if (NetPay === "") {
      NetPayError = "This field is required.";
    } else if (parseFloat(totalSalary) < parseFloat(NetPay)) {
      NetPayError = "Not matched Total Salary";
    }
    if (NetPayError !== "") {
      this.setState({ NetPayError });
      return;
    }
    const selectedContract = this.state.selectedContract;
    showLoader("updatesalary");
    const postData = {
      candidateID: selectedContract.candidateId,
      contractID: selectedContract.id,
      BillMonth: this.getBillMonthStr(),
      BillData: JSON.stringify(this.state.salaryData),
      BillTotalEarning: totalEarning,
      BillTotalDeductions: totalDeductions,
      BillTotalSalary: totalSalary,
      BillNetPay: NetPay,
    };
    axios
      .post(`${downloadUrl}candidate/updateportagebill`, postData, { headers: { Authorization: this.getToken() } })
      .then((res) => {
        hideLoader("updatesalary");
        const successMsg = res?.data?.message || "";
        $("#paySlipDetailsClose").trigger("click");
        if (this.state.viewType === "signon") {
          this.loadBillList(this.state.signOnCurrentPage, this.state.pageLimitSignOn.value);
        } else {
          this.loadSignOffBillList(this.state.signOffCurrentPage, this.state.pageLimitSignOff.value);
        }
        showAlert("Success", successMsg, "success", "No");
      })
      .catch((err) => {
        hideLoader("updatesalary");
        const errorMsg = err?.response?.data?.message || err.message;
        showAlert("Error", errorMsg, "error", "No");
        console.error(err);
      });
  };

  generatePaySlipBulk = (paysliptype, e) => {
    e.preventDefault();
    if (!this.state.billMonth) {
      this.setState({ billMonthError: true });
      return;
    }
    const actionTxt = paysliptype === "1" ? "generate" : "unlock";
    Swal.fire({
      title: "Are you sure?",
      text: `Are you sure you want to ${actionTxt} payslip?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${paysliptype === "1" ? "Generate" : "Unlock"}!`,
    }).then((result) => {
      if (result.isConfirmed) {
        const postData = {
          billMonth: this.getBillMonthStr(),
          vessel: this.state.Billvessel?.value || "",
          paysliptype,
        };
        axios
          .post(`${downloadUrl}candidate/generatePaySlipV1`, postData, { headers: { Authorization: this.getToken() } })
          .then((res) => {
            const successMsg = res?.data?.message || "";
            if (res?.data?.success === true) {
              Swal.fire({ icon: "success", title: "Success", text: successMsg });
              this.loadBillList(1, this.state.pageLimitSignOn.value);
              this.loadSignOffBillList(1, this.state.pageLimitSignOff.value);
            } else {
              Swal.fire({ icon: "error", title: "Error", text: successMsg });
            }
          })
          .catch((err) => {
            const errorMsg = err?.response?.data?.message || err.message;
            Swal.fire({ icon: "error", title: "Error", text: errorMsg });
            console.error(err);
          });
      }
    });
  };

  unlockPayslipRow = (contractID, portagebillID, e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to unlock payslip?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Unlock!",
    }).then((result) => {
      if (result.isConfirmed) {
        const postData = { contractID, portagebillID, paysliptype: "0", billMonth: this.getBillMonthStr() };
        axios
          .post(`${downloadUrl}candidate/generatePaySlipV1`, postData, { headers: { Authorization: this.getToken() } })
          .then((res) => {
            const successMsg = res?.data?.message || "";
            if (res?.data?.success === true) {
              Swal.fire({ icon: "success", title: "Success", text: successMsg });
              this.loadBillList(1, this.state.pageLimitSignOn.value);
              this.loadSignOffBillList(1, this.state.pageLimitSignOff.value);
            } else {
              Swal.fire({ icon: "error", title: "Error", text: successMsg });
            }
          })
          .catch((err) => {
            const errorMsg = err?.response?.data?.message || err.message;
            Swal.fire({ icon: "error", title: "Error", text: errorMsg });
            console.error(err);
          });
      }
    });
  };

  viewPaySlip = (portagebillID, type, e) => {
    e.preventDefault();
    const loaderId = type === "signon" ? "bill-list" : "signoff-bill-list";
    showLoader(loaderId);
    axios
      .post(`${downloadUrl}candidate/viewPaySlipv1`, { portagebillID }, { headers: { Authorization: this.getToken() } })
      .then((res) => {
        hideLoader(loaderId);
        const fileName = res?.data?.fileName;
        if (fileName) {
          const a = document.createElement("a");
          a.href = `${downloadUrl}payslip/${fileName}`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((err) => {
        hideLoader(loaderId);
        console.error(err);
        Swal.fire({ icon: "error", title: "Error", text: "Failed to download" });
      });
  };

  formatMonthYear = (date) => {
    if (date) {
      return format(date, "MMM yyyy");
    }
    return "";
  };

  exportBill = (e) => {
    e.preventDefault();
    if (!this.state.billMonth) {
      this.setState({ billMonthError: true });
      return;
    }
    showLoader("exportitem");
    axios
      .get(`${downloadUrl}candidate/exportportagebill?${this.buildParams()}`, { headers: { Authorization: this.getToken() }, responseType: "blob" })
      .then((response) => {
        hideLoader("exportitem");
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `PortageBill-${this.formatMonthYear(this.state.billMonth)}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((err) => {
        hideLoader("exportitem");
        console.error(err);
      });
  };

  renderRows(resultList, type, loading) {
    if (loading) {
      return (
        <tr>
          <td colSpan={17}>{showContaimerLoader()}</td>
        </tr>
      );
    }
    if (resultList.length === 0) {
      return (
        <tr>
          <td colSpan={17} align="center">
            No Record Found
          </td>
        </tr>
      );
    }
    const currentPage = type === "signon" ? this.state.signOnCurrentPage : this.state.signOffCurrentPage;
    const pageLimit = type === "signon" ? this.state.pageLimitSignOn.value : this.state.pageLimitSignOff.value;
    return resultList.map((result, index) => {
      const portagebillDetails = result?.portagebill || null;
      const poCurrency_ = currencyList[result?.currency || "USD"];
      const BillPaySlip = portagebillDetails?.BillPaySlip || 0;
      return (
        <tr key={index}>
          <td className="text-nowrap">
            {BillPaySlip === 0 && (
              <a href="/" onClick={this.viewSalaryBreackup.bind(this, result, type)} className="me-2">
                <i className="fa fa-usd" aria-hidden="true"></i>
              </a>
            )}
            {BillPaySlip === 1 && portagebillDetails !== null && (
              <>
                <a href="/" onClick={this.viewPaySlip.bind(this, portagebillDetails.portagebillID, type)} className="me-2">
                  <i className="fa fa-file" aria-hidden="true"></i>
                </a>
                {this.isAdmin() && (
                  <a href="/" onClick={this.unlockPayslipRow.bind(this, result.id, portagebillDetails.portagebillID)}>
                    <i className="fa fa-unlock-alt" aria-hidden="true"></i>
                  </a>
                )}
              </>
            )}
          </td>
          <td className="text-nowrap">{(parseInt(currentPage) - 1) * parseInt(pageLimit) + index + 1}</td>
          <td className="text-nowrap">{result.candidateId}</td>
          <td className="text-nowrap">{result.name}</td>
          <td className="text-nowrap">{result.rank}</td>
          <td className="text-nowrap">{result.vesselName}</td>
          <td className="text-nowrap">{result.company_name}</td>
          <td className="text-nowrap">{showDate(result.sign_on)}</td>
          <td className="text-nowrap">{showDate(result.sign_off)}</td>
          <td className="text-nowrap">{showDate(result.eoc)}</td>
          <td className="text-nowrap">{showDate(portagebillDetails?.BillStartDate || result?.startDate || "")}</td>
          <td className="text-nowrap">{showDate(portagebillDetails?.BillEndDate || result?.endDate || "")}</td>
          <td className="text-nowrap">{portagebillDetails?.BillTotalDays || result?.totalDays || 0}</td>
          <td className="text-nowrap">
            {poCurrency_} {parseFloat(portagebillDetails?.BillTotalEarning || result?.totalEarning || 0).toFixed(2)}
          </td>
          <td className="text-nowrap">
            {poCurrency_} {parseFloat(portagebillDetails?.BillTotalDeductions || 0).toFixed(2)}
          </td>
          <td className="text-nowrap">
            {poCurrency_} {parseFloat(portagebillDetails?.BillTotalSalary || result?.totalSalary || 0).toFixed(2)}
          </td>
          <td className="text-nowrap">
            {poCurrency_} {parseFloat(portagebillDetails?.BillNetPay || result?.netSalary || 0).toFixed(2)}
          </td>
        </tr>
      );
    });
  }

  renderTableHead() {
    return (
      <thead>
        <tr className="text-nowrap">
          <th scope="col">Action</th>
          <th scope="col">S.No</th>
          <th scope="col">Nemo ID</th>
          <th scope="col">Name</th>
          <th scope="col">Rank</th>
          <th scope="col">Vessel</th>
          <th scope="col">Company</th>
          <th scope="col">Sign On</th>
          <th scope="col">Sign OFF</th>
          <th scope="col">EOC</th>
          <th scope="col">From</th>
          <th scope="col">To</th>
          <th scope="col">Total Days</th>
          <th scope="col">Total Earning</th>
          <th scope="col">Total Deduction</th>
          <th scope="col">Total Salary</th>
          <th scope="col">Net Salary</th>
        </tr>
      </thead>
    );
  }

  render() {
    const { totalSalaryDetails, totalEarning, totalDeductions, totalSalary } = this.calculateAmount();
    const currency = currencyList[this.state.selectedContract?.currency || "USD"];

    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="portagebill" {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                  </div>
                  <button className="hidden" type="button" data-bs-toggle="modal" data-bs-target="#paySlipDetails" data-backdrop="static" data-keyboard="false" id="paySlipDetailsTrigger">
                    &nbsp;
                  </button>
                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="form-group col-md-3">
                              <label className="form-label">Select Month</label>
                              <DatePicker
                                selected={this.state.billMonth || null}
                                onChange={this.handleMonthChange}
                                showMonthYearPicker
                                dateFormat="MM/yyyy"
                                placeholderText="Select Month"
                                className={`form-control${this.state.billMonthError ? " error" : ""}`}
                                onKeyDown={(e) => e.preventDefault()}
                                isClearable={this.state.billMonth ? true : false}
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <label className="form-label">Vessel</label>
                              <Select
                                value={this.state.Billvessel}
                                onChange={this.handleSelectChange.bind(this, "Billvessel")}
                                placeholder="Select Vessel"
                                isClearable={true}
                                options={this.state.vesselList}
                              />
                            </div>
                            <div className="col-md-2">
                              <div className="mt-6">
                                <a href="/" className="btn btn-primary" onClick={this.searchBill}>
                                  View Bill
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12 text-end mb-3">
                      {this.state.showExport && (
                        <button type="button" className="btn btn-success me-2" id="exportitem" onClick={this.exportBill}>
                          Export
                        </button>
                      )}
                      {this.state.showGeneratePaySlip && (
                        <button type="button" className="btn btn-warning me-2" onClick={this.generatePaySlipBulk.bind(this, "1")}>
                          Generate PaySlip
                        </button>
                      )}
                      {this.state.showUnlockPaySlip && (
                        <button type="button" className="btn btn-danger" onClick={this.generatePaySlipBulk.bind(this, "0")}>
                          Unlock PaySlip
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        <div className="card-header">
                          <h3 className="card-title">Sign ON</h3>
                        </div>
                        <div className="card-body">
                          <div className="col-md-2 mb-3">
                            <Select
                              value={this.state.pageLimitSignOn}
                              onChange={(value) => this.sateValChange("pageLimitSignOn", value, "SignOn")}
                              placeholder="Page Per"
                              options={pageOptions}
                            />
                          </div>
                          <div className="table-responsive">
                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                              {this.renderTableHead()}
                              <tbody id="bill-list">{this.renderRows(this.state.signOnResult, "signon", this.state.signOnLoading)}</tbody>
                            </table>
                          </div>
                          {parseInt(this.state.signOnTotalPage) > 1 && (
                            <Pagenation
                              params={{
                                totalRecords: this.state.signOnTotalRecords,
                                totalPage: this.state.signOnTotalPage,
                                currentPage: this.state.signOnCurrentPage,
                                addParam: "SignOn",
                              }}
                              sateValChange={this.sateValChange}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        <div className="card-header">
                          <h3 className="card-title">SIGN OFF</h3>
                        </div>
                        <div className="card-body">
                          <div className="col-md-2 mb-3">
                            <Select
                              value={this.state.pageLimitSignOff}
                              onChange={(value) => this.sateValChange("pageLimitSignOff", value, "SignOff")}
                              placeholder="Page Per"
                              options={pageOptions}
                            />
                          </div>
                          <div className="table-responsive">
                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                              {this.renderTableHead()}
                              <tbody id="signoff-bill-list">{this.renderRows(this.state.signOffResult, "signoff", this.state.signOffLoading)}</tbody>
                            </table>
                          </div>
                          {parseInt(this.state.signOffTotalPage) > 1 && (
                            <Pagenation
                              params={{
                                totalRecords: this.state.signOffTotalRecords,
                                totalPage: this.state.signOffTotalPage,
                                currentPage: this.state.signOffCurrentPage,
                                addParam: "SignOff",
                              }}
                              sateValChange={this.sateValChange}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="paySlipDetails" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Salary Breakup</h5>
                <button type="button" className="btn-close" id="paySlipDetailsClose" data-bs-dismiss="modal" aria-label="Close" onClick={this.closeSalaryPopup}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="d-flex align-items-center border-primary py-3 px-4 border rounded mb-4">
                  <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                    <p className="mb-0 text-heading">Salary Details</p>
                    <h5 className="mb-0">
                      {currency} {totalSalaryDetails.toFixed(2)}
                    </h5>
                  </div>
                </div>
                <h5 className="pb-4 border-bottom text-capitalize mt-2 mb-2">Additional Earning</h5>
                <div className="row">
                  {earningFields.map((f) => (
                    <div className="col-md-3 mb-3" key={f.key}>
                      <label className="form-label">{f.label}</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Enter ${f.label}`}
                        value={this.state.salaryData[f.key]}
                        onChange={(e) => this.handleSalaryFieldChange(f.key, e.target.value)}
                      />
                    </div>
                  ))}
                  <div className="d-flex align-items-center border-primary py-3 px-4 border rounded mb-4">
                    <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                      <p className="mb-0 text-heading">Total Additional Earning</p>
                      <h5 className="mb-0">
                        {currency} {totalEarning.toFixed(2)}
                      </h5>
                    </div>
                  </div>
                </div>
                <h5 className="pb-4 border-bottom text-capitalize mt-3 mb-2">Deductions</h5>
                <div className="row">
                  {deductionFields.map((f) => (
                    <div className="col-md-3 mb-3" key={f.key}>
                      <label className="form-label">{f.label}</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Enter ${f.label}`}
                        value={this.state.salaryData[f.key]}
                        onChange={(e) => this.handleSalaryFieldChange(f.key, e.target.value)}
                      />
                    </div>
                  ))}
                  <div className="d-flex align-items-center border-primary py-3 px-4 border rounded mb-4">
                    <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                      <p className="mb-0 text-heading">Total Deductions</p>
                      <h5 className="mb-0">
                        {currency} {totalDeductions.toFixed(2)}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex align-items-center border-primary py-3 px-4 border rounded mb-4">
                    <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                      <p className="mb-0 text-heading">Total Salary</p>
                      <h5 className="mb-0">
                        {currency} {totalSalary.toFixed(2)}
                      </h5>
                    </div>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Net Pay</label>
                    <input type="text" className={`form-control${this.state.NetPayError ? " error" : ""}`} placeholder="Enter Net Pay" value={this.state.NetPay} onChange={this.handleNetPayChange} />
                    {this.state.NetPayError && <span className="error">{this.state.NetPayError}</span>}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closeSalaryPopup}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" id="updatesalary" onClick={this.saveSalaryDetails}>
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default List;
